
import { useState, useContext, useEffect } from "react";
import { GlobalContext } from "@src/context/GlobalContext";
import { useNavigate } from "react-router-dom";
import logo1 from "@src/assets/image/logo1.png";
import menu from "@src/assets/image/menu.png";
import "./index.scss";

const Header = () => {
  const { state: { deviceType } } = useContext(GlobalContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const showMenuChange = (e: any) => {
    e.stopPropagation()
    setMenuOpen(true)
  }

  const hiddenMenuChange = () => {
    setMenuOpen(false)
  }

  useEffect(() => {
    window.addEventListener("click", hiddenMenuChange);
    return () => {
      window.removeEventListener("click", hiddenMenuChange);
    }
  },[])

  return (
    <div className="layout-header-wrapper">
      <div className="header_content">
        <div className="header_left">
          <img className="header_logo" src={logo1} alt="" />
          {deviceType == "pc" && <ul className="navigation_menu">
            <li onClick={() => navigate("/")}>Home</li>
            <li onClick={() => navigate("/aboutus")}>About us</li>
          </ul>}
        </div>
        <div className="header_right">
          {deviceType == "pc" && <button className="free_trial" onClick={() => navigate("/contactus")}>Free Trial</button>}
          {deviceType == "mobile" &&
            <div className="header_mobile">
              <img className="header_mobile_menu_icon" src={menu} alt="" onClick={showMenuChange} />
              {menuOpen && <ul className="header_mobile_menu_list">
                <li onClick={() => navigate("/")}>Home</li>
                <li onClick={() => navigate("/aboutus")}>About us</li>
                <li onClick={() => navigate("/contactus")}>Free Trial</li>
              </ul>}
            </div>
          }
        </div>
      </div>
    </div>
  );
}

export default Header;